export const intro =[
    {

    },
    { id:2,

    }
]



export const CheckQuestionArray = [
    {
        id: 1,
        question: "Laquelle des déclarations suivantes attribue la valeur 100 à la variable x en Python :",
        image:"",
        answer: [
            "x := 100",
            "x = 100",
            "let x = 100"
        ],
        correctAnswer:"x = 100"
    },
    {
        id: 2,
        question: "le resultat de script suivant est : ",
        image:"/img/user.jpg",
        answer: [
            "mohammed",
            "youssef",
        ],
        correctAnswer:"mohammed"
    },
    {
        id: 3,
        question: "le resultat de script suivant est : ",
        image:"/img/sport.jpg",
        answer: [
            "sport",
            "B-ball",
        ],
        correctAnswer:"B-ball"
    },
   

]
export const DragQuestionArray = [
    {
        id: 1,
        question: "créer une variable appelée age qui a pour valeur 17",
        answer: [
            "=",
            "age",
            "17"
        ],
        correctAnswer:["age","=","17"]
    },
    {
        id: 2,
        question: "donner au variable name la valeur karin: ",
        answer: [
            '=',
            'name',
            '"karin"'
        ],
        correctAnswer:['name','=', '"karin"']
    },
   

]

export const InputQuestionArray = [
    {
        id: 1,
        question: "créer une variable appelée user_number qui a pour valeur 15",
        correctAnswer:["user_number=15","user_number =15","user_number = 15","user_number= 15"]
    },
    {
        id: 2,
        question: "Which of the following statements assigns the value 100 to the variable x in Python:",
        correctAnswer:["nom=sami","nom = sami","nom =sami","nom= sami"]
    },
   

]